import { useLocation, useNavigate } from 'react-router-dom';
import {Box, Button, Stack, styled} from '@mui/material';
import { routes } from 'app/providers/router/routes';
import { useWeb3Auth } from 'app/providers/Web3AuthProvider';
import { userSelector } from 'entities/user';
import { ConnectButton } from 'features/connect-button';
import { logoImage } from 'shared/assets';
import { useShallowSelector } from 'shared/hooks';
import { useTranslation } from 'react-i18next';
import {
    StyledHeader,
    Nav,
    Logo,
    LangWrapper,
    MobileLang,
    SelectedLang,
    Dropdown,
} from "../../pages/home/ui/MainPage/styles/StyledHeader";
import { ContainerMain } from "../../pages/home/ui/MainPage/styles/ContainerMain";
import {logoWhiteEngMinH, logoWhiteEngMinV, logoBlackEngMinH, logoBlackEngMinV, logoBlackEngH ,logoBlackEngV ,logoBlackRusH ,logoBlackRusV ,logoWhiteEngH ,logoWhiteEngV ,logoWhiteRusH ,logoWhiteRusV  } from 'shared/assets';
import { useState, useEffect, useRef } from "react";
import { useTheme } from "../../app/providers/ThemeContext";

const ButtonM = styled(Button)`
 
  padding: 12px 20px;
  font-weight: 500;
  font-size: 16px;
  color: #4f4f4f;
  font-family: "Montserrat", sans-serif;
  margin-left: 20px;
  cursor: pointer;
  height: 43px;
  transition: all 0.3s ease;
  border: 1px solid transparent;
  &:hover {
    color: #000;
    background: #fff;
  }
  @media (max-width: 768px) {
    padding: 8px 10px;
    margin-left: 0px;
  }
`;

export const Header = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const isHomePage = pathname === '/';
  const { id: userId } = useShallowSelector(userSelector.getUser);
  const { logout } = useWeb3Auth();

  const { t, i18n } = useTranslation();
  const handleLogoClick = () => {
    navigate(routes.home.path);
  };

    const [isOpen, setIsOpen] = useState(false);
    const [curentLogo, setcurentLogo] = useState(logoWhiteEngH);
    const [selectedLang, setSelectedLang] = useState("RU");

    const dropdownRef = useRef(null);
    const selectedLangRef = useRef(null);

    const { themeMode } = useTheme();
    const handleLangChange = (lang: any) => {
        setSelectedLang(lang);
        i18n.changeLanguage(lang);
        setIsOpen(false);
    };

    const changeLanguageRU = () => {
        i18n.changeLanguage("ru")
            if(themeMode == 'light') {
                setcurentLogo(logoWhiteRusH);
            } else {
                setcurentLogo(logoBlackRusV);
            }
        };
        const changeLanguageEN = () => {
            i18n.changeLanguage("en")
            if(themeMode == 'light') {
                setcurentLogo(logoWhiteEngH);
            } else {
                setcurentLogo(logoBlackEngV);
            }
        };
    useEffect(() => {
        const handleClickOutside = (event: any) => {
            // @ts-ignore
            if (dropdownRef.current && !dropdownRef.current.contains(event.target) && !selectedLangRef.current.contains(event.target)
            ) {
                setIsOpen(false);
            }
        };
        if(themeMode == 'light') {
            if(i18n.language == 'en') {
                setcurentLogo(logoWhiteEngH);
            } else {
                setcurentLogo(logoWhiteRusH);
            }
        } else {
            if(i18n.language == 'en') {
                setcurentLogo(logoBlackEngV);
            } else {
                setcurentLogo(logoBlackRusV);
            }
        }

        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, [themeMode]);



    return (
        <StyledHeader>
            <ContainerMain>
                <Nav>
                    <Logo src={curentLogo} alt="Web3Wed" onClick={handleLogoClick} />
                    <div>
                        <LangWrapper>
                            <button onClick={changeLanguageRU}>RU</button>
                            <button onClick={changeLanguageEN}>EN</button>
                        </LangWrapper>
                        <MobileLang>
                            <SelectedLang
                                onClick={() => setIsOpen(!isOpen)}
                                ref={selectedLangRef}
                            >
                                {selectedLang}
                            </SelectedLang>
                            {isOpen && (
                                <Dropdown ref={dropdownRef}>
                                    {["ru", "en"].map(
                                        (lang) =>
                                            lang !== selectedLang && (
                                                <button
                                                    key={lang}
                                                    onClick={() => handleLangChange(lang)}
                                                >
                                                    {lang}
                                                </button>
                                            )
                                    )}
                                </Dropdown>
                            )}
                        </MobileLang>
                        {userId && !isHomePage ? (
                            <ButtonM
                                variant="outlined"
                                onClick={logout}
                            >
                                {t('header_button_logout')}
                            </ButtonM>
                        ) : (
                            <ConnectButton />
                        )}
                    </div>
                </Nav>
            </ContainerMain>
        </StyledHeader>
    );
};
